{
  "errors": {
    "noBulletins": "Inga anslag tillgängliga",
    "bulletinsFetchError": "Ett fel uppstod när anslagen hämtades",
    "errorLoadingBulletin": "Fel vid hämtning av anslag. Försök igen senare."
  },
  "edited": "Redigerad"
}
